import { createApp } from 'vue'
import App from './App.vue'
import vSelect from 'vue-select'
import html2canvas from 'html2canvas'
import VueTheMask from 'vue-the-mask'
import * as JsPDF from 'jspdf'
createApp(App).component('v-select', vSelect).use(VueTheMask).mount('#app')
